// extracted by mini-css-extract-plugin
export var cardIcon = "_9b-5";
export var checkboxCard = "_9b-0";
export var checkboxCardSelected = "_9b-4";
export var disabled = "_9b-2";
export var interactive = "_9b-1";
export var outerBorder = "_9b-3";
export var spacerMedium = "_9b-8";
export var spacerSmall = "_9b-7";
export var spacerXsmall = "_9b-6";